import { render, staticRenderFns } from "./mangelPrioritaet.vue?vue&type=template&id=26968434"
import script from "./mangelPrioritaet.vue?vue&type=script&lang=js"
export * from "./mangelPrioritaet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports